import { render, staticRenderFns } from "./TifJustificacionesModal.vue?vue&type=template&id=17695cb9"
import script from "./TifJustificacionesModal.vue?vue&type=script&lang=js"
export * from "./TifJustificacionesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports